/* DIREVULF — SORT BY on collection and search pages.

   APPLYING A SORT
   The desktop sort control is a real GET form (snippets/sort-select.liquid)
   whose Apply button only exists inside <noscript>. Choosing an order builds
   the new URL from the current one — so the search query and every active
   filter and price range survive exactly as they are; only sort_by changes,
   and the page number is dropped because page 3 of the old order is not
   page 3 of the new one — and hands it to plp.js, which updates the results
   in place (Section Rendering API) and records the URL in history. If plp.js
   is not there, the page navigates to that URL as it always did.

   THE CONTROL ITSELF (desktop)
   The native <select> dropdown is a separate operating-system window. On
   Windows it drew a black box and then an oversized white one every time it
   opened — the flicker in the recording — and a page cannot style or fix
   that window. So on desktop the <select> is hidden (it stays in the form as
   the submitted value and the no-JavaScript control) and a button plus an
   in-page listbox, drawn to look like the select, takes its place. It follows
   the WAI-ARIA select-only combobox pattern: Enter, Space, Up and Down open
   it; Up/Down/Home/End move; Enter or Space chooses; Escape and Tab close;
   typing a letter jumps to the matching option.

   plp.js re-renders the heading this control lives in after every filter or
   sort change, so mount() is idempotent and plp.js calls it again. */
(function () {
  'use strict';

  var uid = 0;

  function urlFor(value) {
    var params = new URLSearchParams(window.location.search);
    params.set('sort_by', value);
    params.delete('page');
    params.delete('section_id');
    return window.location.pathname + '?' + params.toString();
  }

  function apply(value) {
    if (!value) return;
    var params = new URLSearchParams(window.location.search);
    if (params.get('sort_by') === value) return;
    var url = urlFor(value);
    if (window.DirevulfPLP && window.DirevulfPLP.go) {
      window.DirevulfPLP.go(url);
    } else {
      var body = document.querySelector('[data-dv-collection-body]');
      if (body) body.setAttribute('aria-busy', 'true');
      window.location.assign(url + '#dv-products');
    }
  }

  var CHEVRON = '<svg viewBox="0 0 12 12" aria-hidden="true" focusable="false"><path d="M2.5 4.5 6 8l3.5-3.5" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var CHECK = '<svg viewBox="0 0 12 12" aria-hidden="true" focusable="false"><path d="M2.5 6.2 5 8.6l4.5-5" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function enhance(select) {
    if (select.hasAttribute('data-dv-sortbox')) return;
    select.setAttribute('data-dv-sortbox', '');
    var n = ++uid;
    var form = select.form || select.parentNode;
    var label = form.querySelector('label[for="' + select.id + '"]');

    var box = document.createElement('div');
    box.className = 'dv-sortbox';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'dv-sortbox__btn';
    btn.id = 'DvSortBtn' + n;
    btn.setAttribute('aria-haspopup', 'listbox');
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-controls', 'DvSortList' + n);
    var text = document.createElement('span');
    btn.appendChild(text);
    btn.insertAdjacentHTML('beforeend', CHEVRON);

    var list = document.createElement('ul');
    list.className = 'dv-sortbox__list';
    list.id = 'DvSortList' + n;
    list.setAttribute('role', 'listbox');
    list.setAttribute('tabindex', '-1');
    list.hidden = true;
    if (label) {
      if (!label.id) label.id = 'DvSortLabel' + n;
      list.setAttribute('aria-labelledby', label.id);
      btn.setAttribute('aria-labelledby', label.id + ' ' + btn.id);
      label.setAttribute('for', btn.id);
    } else {
      list.setAttribute('aria-label', select.getAttribute('aria-label') || '');
      btn.setAttribute('aria-label', select.getAttribute('aria-label') || '');
    }

    var opts = Array.prototype.map.call(select.options, function (o, i) {
      var li = document.createElement('li');
      li.className = 'dv-sortbox__opt';
      li.id = 'DvSortOpt' + n + '-' + i;
      li.setAttribute('role', 'option');
      li.setAttribute('data-value', o.value);
      var span = document.createElement('span');
      span.textContent = o.textContent.trim();
      li.appendChild(span);
      list.appendChild(li);
      return li;
    });

    var active = 0;

    function paint() {
      var i = Math.max(select.selectedIndex, 0);
      text.textContent = select.options[i] ? select.options[i].textContent.trim() : '';
      opts.forEach(function (li, k) {
        var on = k === i;
        li.setAttribute('aria-selected', on ? 'true' : 'false');
        var mark = li.querySelector('svg');
        if (on && !mark) li.insertAdjacentHTML('beforeend', CHECK);
        if (!on && mark) mark.remove();
      });
    }

    function setActive(i) {
      active = Math.max(0, Math.min(opts.length - 1, i));
      opts.forEach(function (li, k) { li.classList.toggle('is-active', k === active); });
      list.setAttribute('aria-activedescendant', opts[active].id);
      var li = opts[active];
      if (li.offsetTop < list.scrollTop) list.scrollTop = li.offsetTop;
      else if (li.offsetTop + li.offsetHeight > list.scrollTop + list.clientHeight) list.scrollTop = li.offsetTop + li.offsetHeight - list.clientHeight;
    }

    function isOpen() { return !list.hidden; }

    function open() {
      if (isOpen()) return;
      list.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
      setActive(Math.max(select.selectedIndex, 0));
      list.focus({ preventScroll: true });
      document.addEventListener('pointerdown', outside, true);
    }

    function close(refocus) {
      if (!isOpen()) return;
      list.hidden = true;
      btn.setAttribute('aria-expanded', 'false');
      list.removeAttribute('aria-activedescendant');
      document.removeEventListener('pointerdown', outside, true);
      if (refocus) btn.focus({ preventScroll: true });
    }

    function outside(event) {
      if (!box.contains(event.target)) close(false);
    }

    function choose(i) {
      var value = opts[i].getAttribute('data-value');
      close(true);
      if (select.value === value) return;
      select.value = value;
      paint();
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }

    btn.addEventListener('click', function () { if (isOpen()) close(true); else open(); });
    btn.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        open();
      }
    });

    list.addEventListener('click', function (event) {
      var li = event.target.closest('[role="option"]');
      if (li) choose(opts.indexOf(li));
    });
    list.addEventListener('mousemove', function (event) {
      var li = event.target.closest('[role="option"]');
      if (li) { var i = opts.indexOf(li); if (i !== active) setActive(i); }
    });

    var typed = '';
    var typedAt = 0;
    list.addEventListener('keydown', function (event) {
      var k = event.key;
      if (k === 'ArrowDown') { event.preventDefault(); setActive(active + 1); }
      else if (k === 'ArrowUp') { event.preventDefault(); setActive(active - 1); }
      else if (k === 'Home') { event.preventDefault(); setActive(0); }
      else if (k === 'End') { event.preventDefault(); setActive(opts.length - 1); }
      else if (k === 'Enter' || k === ' ') { event.preventDefault(); choose(active); }
      else if (k === 'Escape') { event.preventDefault(); close(true); }
      else if (k === 'Tab') { close(false); }
      else if (k.length === 1 && /\S/.test(k)) {
        var now = Date.now();
        typed = (now - typedAt > 700 ? '' : typed) + k.toLowerCase();
        typedAt = now;
        for (var i = 0; i < opts.length; i++) {
          if (opts[i].textContent.trim().toLowerCase().indexOf(typed) === 0) { setActive(i); break; }
        }
      }
    });
    list.addEventListener('focusout', function (event) {
      if (!box.contains(event.relatedTarget)) close(false);
    });

    select.classList.add('dv-sortbox__native');
    select.setAttribute('tabindex', '-1');
    select.setAttribute('aria-hidden', 'true');
    box.appendChild(btn);
    box.appendChild(list);
    select.parentNode.insertBefore(box, select.nextSibling);
    paint();
  }

  function mount(root) {
    var selects = (root || document).querySelectorAll('[data-dv-sort-form] [data-dv-sort-select]');
    for (var i = 0; i < selects.length; i++) enhance(selects[i]);
  }

  /* One delegated listener, so a sort control re-rendered by plp.js needs no
     re-binding. */
  document.addEventListener('change', function (event) {
    var select = event.target;
    if (!select.matches || !select.matches('[data-dv-sort-form] [data-dv-sort-select]')) return;
    apply(select.value);
  });

  window.DirevulfSortbox = { mount: mount };
  mount(document);
})();
